import { render, staticRenderFns } from "./ShipbluCard.vue?vue&type=template&id=5f47b193"
import script from "./ShipbluCard.vue?vue&type=script&lang=js"
export * from "./ShipbluCard.vue?vue&type=script&lang=js"
import style0 from "./ShipbluCard.vue?vue&type=style&index=0&id=5f47b193&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports